import { ThemeOptions } from '@mui/material';

import * as MuiAvatar from './MuiAvatar';
import * as MuiBadge from './MuiBadge';
import * as MuiChip from './MuiChip';
import * as MuiDataGrid from './MuiDataGrid';
import * as MuiDivider from './MuiDivider';
import * as MuiList from './MuiList';
import * as MuiMenu from './MuiMenu';
import * as MuiTable from './MuiTable';
import * as MuiTooltip from './MuiTooltip';
import * as MuiTypography from './MuiTypography';

export type {} from './MuiAvatar';
export type {} from './MuiBadge';
export type {} from './MuiChip';
export type {} from './MuiDataGrid';
export type {} from './MuiDivider';
export type {} from './MuiList';
export type {} from './MuiMenu';
export type {} from './MuiTable';
export type {} from './MuiTooltip';
export type {} from './MuiTypography';

export const dataDisplay: ThemeOptions['components'] = {
  ...MuiChip,
  ...MuiDivider,
  ...MuiList,
  ...MuiTypography,
  ...MuiTable,
  ...MuiDataGrid,
  ...MuiBadge,
  ...MuiMenu,
  ...MuiTooltip,
  ...MuiAvatar
};
